export default __webpack_public_path__ + "static/media/Coping Mechanisms - Addiction worksheet.37a93f8a.pdf";